// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2pne7","gfeWrapper":"CalendarEvent_gfeWrapper__2nqCI"};